// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3o_xQ","legacyBtn":"MutateMid_legacyBtn__u9XdK"};